module.exports = __webpack_public_path__ + "img/arrow-right.b5a95e1e.svg";